<template lang="pug">
  include ./../../../mixins
  div(@click.prevent='openPopup()')
    slot(name='title')
    slot(name='icon')
    slot(name='content')
</template>

<script>

export default {
  name: 'ModalTrigger',
  props: {
    url: {
      type: String,
      default: () => null,
    },
    name: {
      type: String,
    },
    className: {
      type: String,
      default: 'v--modal',
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    text: {
      type: String,
    },
    icon: {
      type: String,
    },
    fromTitle: {
      type: String,
    },
    transGroup: {},
    listSelect: [],
    updateData: {},
  },
  methods: {
    openPopup() {
      this.$modal.show(this.componentLoader,
        {
          title: this.title,
          icon: this.icon,
          text: this.text,
          subtitle: this.subtitle,
          fromTitle: this.fromTitle,
          transGroup: this.transGroup,
          updateData: this.updateData,
        }, {
          name: this.name,
          width: '100%',
          height: 'auto',
          adaptive: true,
          scrollable: true,
          classes: this.className,
        })
    },
  },
  computed: {
    componentLoader() {
      const components = {
        'components/app/Modals/ModalConsultation': () => import('src/components/app/Modals/ModalConsultation.vue'),
        'components/app/Modals/ModalTecnologies': () => import('src/components/app/Modals/ModalTecnologies.vue'),
        'components/app/Modals/ModalTopic': () => import('src/components/app/Modals/ModalTopic.vue'),
      };
      return components[this.url];
    },
  },
}
</script>



// WEBPACK FOOTER //
// ./src/js/components/app/UiElements/ModalTrigger.vue